/**
 * Single source for renderer state copy — wording is contract, so it lives in
 * one place. Change a string here, not in the views.
 */

export const EM_DASH = '—';

/** Reference stub: unfetchable target degrades to a display-text placeholder. */
export const REFERENCE_UNAVAILABLE_SUFFIX = '(unavailable)';
export const REFERENCE_UNAVAILABLE_FALLBACK = 'Unavailable';
/** Depth-exhausted reference: resource IS available, just not expanded — never "(unavailable)". */
export const REFERENCE_NOT_EXPANDED = 'Not expanded';
export const REFERENCE_DEPTH_TOOLTIP =
  'Not expanded — reference-depth limit reached';

/** Benign data-absent-reason (unknown, not-asked, …): plain not-recorded em-dash + a tooltip naming the reason. */
export function darReasonTooltip(reason: string): string {
  return `Not recorded — ${reason.replace(/-/g, ' ')}`;
}

/** Reference target already rendered higher in this tree (cycle guard). */
export const CYCLE_ALREADY_SHOWN = 'Already shown';

/** Withheld field: one uniform label across all feeding mechanisms; the mechanism only differs in the tooltip. */
export const WITHHELD_LABEL = 'Withheld';
export const WITHHELD_TOOLTIP: Record<'policy' | 'masked', string> = {
  policy: 'Hidden by your access policy — content unknown to this app',
  masked: 'Masked at the source',
};

/** Empty section on a patient-facing surface: "no X visible", never "patient has no X" — rows can be withheld silently. */
export function emptySectionCopy(label: string): string {
  return `No ${label.toLowerCase()} visible.`;
}
